<template>
  <v-app>
    <v-main class="main">

      <!-- Sidebar -->
      <AdminSidebar :drawerOpen="drawerOpen" :collapsed="isSidebarCollapsed" :isMobile="isMobile"
        @update:drawerOpen="drawerOpen = $event" />

      <v-container fluid class="main-content pa-4">

        <!-- Header -->
        <Header :isDarkMode="isDarkMode" :isMobile="isMobile" @toggle-sidebar="toggleSidebar" />

        <v-row dense class="g-2" style="height: 100%; padding: 16px;">

          <!-- top area -->
          <v-col cols="12">

            <!-- LOADING STATE Header skeleton-->
            <div v-if="loading" class="d-flex align-center gap-2 mb-4">

              <!-- Avatar -->
              <v-skeleton-loader type="avatar" size="80" class="mr-2" />

              <!-- Text -->
              <div style="flex:1">
                <v-skeleton-loader type="heading" width="200" class="mb-2" />
                <v-skeleton-loader type="text" width="180" class="mb-2" />
                <v-skeleton-loader type="chip" width="120" />
              </div>

            </div>
            <!-- <div v-else class="d-flex align-center gap-2 mb-4">
              <v-avatar size="80" style="margin-right: 10px;">
                <img
                  :src="user?.profile?.profile_photo ? `${STORAGE_URL}/${user?.profile?.profile_photo}` : defaultImage"
                  class="product-image" />
              </v-avatar>
              <div class="text-left">
                <div class="font-weight-bold text-body-1">
                  <h3>{{ user?.profile?.firstname }} {{ user?.profile?.lastname }}</h3>
                </div>
                <div class="text-caption text-grey">
                  <h4>Registered On {{ formatDateTime(user?.created_at) }}</h4>
                </div>
                <div class="text-caption text-grey">
                  <span :class="[
                    'status-pill',
                    user?.profile?.verification_status === 'completed'
                      ? 'status-active'
                      : 'status-inactive'
                  ]">
                    {{ user?.profile?.verification_status === 'completed' ? 'Verified' : 'Not Verified' }}
                  </span>
                </div>
              </div>
            </div> -->
            <!-- <div v-else class="d-flex align-center justify-space-between mb-4"> -->

            <!-- Left side: avatar + info -->
            <div class="profile-header">
              <!-- Left -->
              <div class="profile-info">
                <v-avatar size="80">
                  <img :src="user?.profile?.profile_photo
                    ? `${STORAGE_URL}/${user?.profile?.profile_photo}`
                    : defaultImage" class="product-image" />
                </v-avatar>

                <div class="text-left">
                  <h3 class="font-weight-bold mb-1">
                    {{ user?.profile?.firstname }} {{ user?.profile?.lastname }}
                  </h3>

                  <div class="text-caption text-grey mb-2">
                    Registered On {{ formatDateTime(user?.created_at) }}
                  </div>

                  <!-- Verification Badge -->
      
                  <span :class="[
                    'status-pill',
                    user?.profile?.verification_status === 'completed'
                      ? 'status-active'
                      : 'status-inactive'
                  ]">
                    {{
                      user?.profile?.verification_status === 'completed'
                        ? 'Verified'
                        : 'Not Verified'
                    }}
                  </span>
                  <!-- Suspend / Unsuspend Button -->
                <v-btn
                  size="small"
                  :color="user?.is_suspended ? 'success' : 'error'"
                  variant="flat"
                  class="mb-2"
                  :loading="suspendingUser"
                  :disabled="suspendingUser"
                  @click="toggleSuspension(user)"
                >
                  <!-- {{ user?.is_suspended ? 'Unsuspend' : 'Suspend' }} -->
                    {{
                      suspendingUser
                        ? (user?.is_suspended ? 'Unsuspending...' : 'Suspending...')
                        : (user?.is_suspended ? 'Unsuspend' : 'Suspend')
                    }}
                </v-btn>

                </div>
              </div>

              <!-- Right -->
              <v-btn v-if="user?.profile?.verification_status !== 'completed'" color="success" class="verify-btn" :loading="verifyingUser" :disabled="verifyingUser"
                @click="verifyUser(user)">
                {{ verifyingUser ? "Verifying..." : "Verify User" }}
              </v-btn>
            </div>

            <!-- </div> -->

            <!--Loading effect-->
            <div v-if="loading" class="pa-6">

              <!-- Main layout -->
              <v-row dense>

                <!-- LEFT COLUMN -->
                <v-col cols="12" md="7">
                  <v-card class="pa-10" rounded="lg">

                    <v-skeleton-loader type="heading" width="40%" class="mb-6" />

                    <!-- Rows -->
                    <div v-for="n in 6" :key="n" class="mb-4">
                      <div class="d-flex justify-space-between align-center">
                        <v-skeleton-loader type="text" width="80" />
                        <v-skeleton-loader type="text" width="120" />
                      </div>
                      <v-divider class="mt-3" />
                    </div>

                  </v-card>
                </v-col>

                <!-- RIGHT COLUMN -->
                <v-col cols="12" md="5">
                  <v-card class="pa-10" rounded="lg">

                    <v-skeleton-loader type="heading" width="60%" class="mb-6" />

                    <div v-for="n in 5" :key="n" class="mb-4">
                      <div class="d-flex justify-space-between align-center">
                        <v-skeleton-loader type="text" width="80" />
                        <v-skeleton-loader type="text" width="120" />
                      </div>
                      <v-divider class="mt-3" />
                    </div>

                  </v-card>
                </v-col>

              </v-row>

            </div>

            <!-- Actual content --> 
            <div v-else>
              <!-- INNER ROW (THIS FIXES YOUR ISSUE) -->
              <v-row dense class="mt-4">
                <!-- LEFT COLUMN -->
                <v-col cols="12" md="7" class="d-flex flex-column">

                  <!-- TOP CARD -->
                  <v-card class="inner-mini-card mb-3 flex-grow-1" flat>
                    <div class="pa-10">
                      <div class="text-small mt-2">
                        <div class="d-flex justify-space-between py-2 mb-3">
                          <span>Email</span>
                          <span>{{ user?.email }}</span>
                        </div>
                        <hr class="title-separator" />
                        <div class="d-flex justify-space-between py-2 mb-3">
                          <span>Phone</span>
                          <span>{{ user?.mobile_number }}</span>
                        </div>
                        <hr class="title-separator" />
                        <div class="d-flex justify-space-between py-2 mb-3">
                          <span>Gender</span>
                          <span>{{ user?.profile?.profile?.gender }}</span>
                        </div>
                        <hr class="title-separator" />
                        <div class="d-flex justify-space-between py-2 mb-3">
                          <span>Address</span>
                          <span>{{ user?.profile?.address_line_1 }}</span>
                        </div>
                        <hr class="title-separator" />
                        <div class="d-flex justify-space-between py-2 mb-3">
                          <span>Referral Code</span>
                          <span>{{ user?.referral_code }}</span>
                        </div>
                        <hr class="title-separator" />
                        <div class="d-flex justify-space-between py-2 mb-3">
                          <span>Username</span>
                          <span>{{ user?.profile?.username }}</span>
                        </div>
                        <hr class="title-separator" />

                        <div class="d-flex justify-space-between align-center py-2 mb-3">
                          <span>Virtual Account</span>

                          <div class="d-flex align-center gap-3">
                            <div class="text-right">
                              <div class="font-weight-medium">
                                {{ user?.profile?.v_bank_number ?? 'Not Generated' }}
                              </div>

                              <div class="text-caption text-grey">
                                {{ user?.profile?.v_bank_name ?? '' }}
                              </div>

                              <div class="text-caption text-grey">
                                {{ user?.profile?.v_bank_acct_name ?? '' }}
                              </div>
                            </div>

                            <v-tooltip text="Regenerate Virtual Account" location="top">
                              <template #activator="{ props }">
                                <v-btn v-bind="props" icon size="small" color="primary" variant="text" :loading="regeneratingVA"
                                  @click="regenerateNewVA(user)">
                                  <v-icon>mdi-refresh</v-icon>
                                </v-btn>
                              </template>
                            </v-tooltip>
                          </div>
                        </div>

                        <hr class="title-separator" />
                        <div class="d-flex justify-space-between align-center py-2 mb-3">
                          <span>Referral Details</span>
                          <div class="text-right">
                            <div class="font-weight-medium">
                             Total Referred  {{ referral_count ?? 0 }}
                            </div>

                            <div class="text-caption text-grey">
                              Total Bonus  {{ referral_bonus ?? 0 }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card>

                </v-col>

                <!-- RIGHT COLUMN -->
                <v-col cols="12" md="5" class="d-flex">

                  <v-card class="inner-card flex-grow-1" flat>
                    <div class="pa-10">
                      <div class="text-subtitle-1 font-weight-medium">
                        <div class="column-title mb-6">
                          <h5 class="m-0 text-left text-grey">Next of Kin Details</h5>
                        </div>
                      </div>
                      <div class="text-small mt-2">
                        <div class="d-flex justify-space-between py-2 mb-3">
                          <span>Full Name</span>
                          <span>{{ nok?.firstname }} {{ nok?.lastname }}</span>
                        </div>
                        <hr class="title-separator" />
                        <div class="d-flex justify-space-between py-2 mb-2">
                          <span>Email</span>
                          <span>{{ nok?.email }}</span>
                        </div>
                        <hr class="title-separator" />
                        <div class="d-flex justify-space-between py-2 mb-2">
                          <span>Phone</span>
                          <span>{{ nok?.phone }}</span>
                        </div>
                        <hr class="title-separator" />
                        <div class="d-flex justify-space-between py-2 mb-2">
                          <span>Relationship</span>
                          <span>{{ nok?.relationship }}</span>
                        </div>
                        <hr class="title-separator" />
                        <div class="d-flex justify-space-between py-2 mb-2">
                          <span>Added On</span>
                          <span>{{ formatDateTime(nok?.created_at) }}</span>
                        </div>
                      </div>
                    </div>
                  </v-card>
                </v-col>

              </v-row>
            </div>
          </v-col>

          <!--Wallet and Investment-->
          <v-col cols="12" md="12" class="mt-10">
            <v-tabs v-model="activeTab" grow bg-color="transparent" class="mb-4">

              <v-tab value="wallet" class="long-tab">
                Wallet Transactions ({{ walletTransactions.length }})
              </v-tab>

              <v-tab value="investment" class="long-tab">
                Investment Transactions ({{ investmentTransactions.length }})
              </v-tab>
            </v-tabs>
            <v-window v-model="activeTab">

              <!-- Wallet Transactions -->
              <v-window-item value="wallet">
                <v-card class="pa-4">

                  <!-- Loader -->
                  <v-skeleton-loader v-if="loadingWallet" type="table" />
                  <DataTable v-else :value="walletTransactions" paginator :rows="10" dataKey="id" stripedRows
                    class="modern-table" :rowsPerPageOptions="[5, 10, 20, 50]" tableStyle="min-width: 50rem"
                    filterDisplay="menu">

                    <Column header="Transaction ID">
                      <template #body="slotProps">
                        <div class="product-cell">
                          <div>
                            {{ slotProps.data.transaction_id }}
                          </div>
                        </div>
                      </template>
                    </Column>
                    <Column header="Amount">
                      <template #body="slotProps">
                        <div class="product-cell">
                          <div>
                            {{ formatCurrency(slotProps.data.amount) }}
                          </div>
                        </div>
                      </template>
                    </Column>
                    <Column header="Type">
                      <template #body="slotProps">
                        <div class="product-cell">
                          <v-icon :color="isOutgoing(slotProps.data.type) ? 'red' : 'green'" size="28">
                            {{ isOutgoing(slotProps.data.type)
                              ? 'mdi-arrow-top-right-bold-box'
                              : 'mdi-arrow-bottom-left-bold-box'
                            }}
                          </v-icon>
                          <div>
                            {{ slotProps.data.description }}
                          </div>
                        </div>
                      </template>
                    </Column>
                    <Column header="Status">
                      <template #body="slotProps">
                        <div class="product-cell">
                          <div>
                            <span :class="[
                              'status-pill',
                              slotProps.data.status === 'successful'
                                ? 'status-active'
                                : 'status-inactive'
                            ]">
                              {{ slotProps.data.status === 'successful' ? 'Successful' : 'Pending' }}
                            </span>
                          </div>
                        </div>
                      </template>
                    </Column>
                    <Column header="Occured At">
                      <template #body="slotProps">
                        <div class="product-cell">
                          <div>
                            {{ formatDateTime(slotProps.data.created_at) }}
                          </div>
                        </div>
                      </template>
                    </Column>
                  </DataTable>
                </v-card>
              </v-window-item>

              <!-- Investment Transactions -->
              <v-window-item value="investment">
                <v-card class="pa-4">

                  <v-skeleton-loader v-if="loadingInvestment" type="table" />
                  <DataTable v-else :value="investmentTransactions" paginator :rows="10" dataKey="id" stripedRows
                    class="modern-table" :rowsPerPageOptions="[5, 10, 20, 50]" tableStyle="min-width: 50rem"
                    filterDisplay="menu">

                    <Column header="Investment">
                      <template #body="slotProps">
                        <div class="product-cell">
                          <div>
                            {{ slotProps.data.product.product_name }}
                          </div>
                        </div>
                      </template>
                    </Column>
                    <Column header="Amount">
                      <template #body="slotProps">
                        <div class="product-cell">
                          <div>
                            {{ formatCurrency(slotProps.data.price) }}
                          </div>
                        </div>
                      </template>
                    </Column>

                    <Column header="Current Yield">
                      <template #body="slotProps">
                        <div class="product-cell">
                          <div>
                            {{ formatCurrency(slotProps.data.accumulated_yield) }}
                          </div>
                        </div>
                      </template>
                    </Column>

                    <Column header="Expected Payout">
                      <template #body="slotProps">
                        <div class="product-cell">
                          <div>
                            {{ formatCurrency(slotProps.data.expected_payout) }}
                          </div>
                        </div>
                      </template>
                    </Column>

                    <Column header="Interest Rate">
                      <template #body="slotProps">
                        <div class="product-cell">
                          <div>
                            {{ formatNumber(slotProps.data.product.interest_rate) }} %
                          </div>
                        </div>
                      </template>
                    </Column>

                    <Column header="Interest Amount">
                      <template #body="slotProps">
                        <div class="product-cell">
                          <div>
                            {{ formatCurrency(slotProps.data.daily_yield) }}
                          </div>
                        </div>
                      </template>
                    </Column>

                    <Column header="Duration">
                      <template #body="slotProps">
                        <div class="product-cell">
                          <div>
                            {{ formatDate(slotProps.data.product.created_at) }} - {{
                              formatDate(slotProps.data.maturity_date) }}
                          </div>
                        </div>
                      </template>
                    </Column>

                    <Column header="Status">
                      <template #body="slotProps">
                        <div class="product-cell">
                          <div>
                            <span :class="[
                              'status-pill',
                              slotProps.data.status === 'active'
                                ? 'status-ongoing'
                                : 'status-completed'
                            ]">
                              {{ slotProps.data.status === 'active' ? 'Active' : 'Completed' }}
                            </span>
                          </div>
                        </div>
                      </template>
                    </Column>

                  </DataTable>
                </v-card>
              </v-window-item>

            </v-window>

          </v-col>
        </v-row>
        <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000" location="top right"> {{
          snackbar.message }}
          <template #actions>
            <v-btn variant="outlined" @click="snackbar.show = false">
              Cancel
            </v-btn>
          </template>
        </v-snackbar>
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed, watch } from "vue"
import AdminSidebar from "@/components/AdminSidebar.vue"
import Header from "@/components/Header.vue"
import { userStore } from "@/store/user"
import { useTransactStore } from "@/store/transaction"
import { useInvStore } from "@/store/investment"
import { STORAGE_URL } from "@/api/http"
import { useRoute } from "vue-router"
import avatarImage from '@/assets/icon.png'
import { formatCurrency, formatDate, formatDateTime, formatNumber, getAllErrors } from "@/util"
import { regenerateVirtualAccount, suspendUser, unsuspendUser, verifyUserAccount } from "@/api/user"

//import { useRouter } from "vue-router"


const usr = userStore()
const transact = useTransactStore()
const invest = useInvStore()
const route = useRoute()

const isSidebarCollapsed = ref(false)
const drawerOpen = ref(false)
const isMobile = ref(false)
const loading = ref(true)
const activeTab = ref("wallet")
const defaultImage = avatarImage
const userId = route.params.id
const regeneratingVA = ref(false)
const verifyingUser = ref(false)
const suspendingUser = ref(false)

// Loading states per tab
const loadingWallet = ref(false)
const loadingInvestment = ref(false)

/* Mobile */
const toggleSidebar = () => {
  if (isMobile.value) drawerOpen.value = !drawerOpen.value
  else isSidebarCollapsed.value = !isSidebarCollapsed.value
}

const checkMobile = () => {
  isMobile.value = window.innerWidth < 768
  drawerOpen.value = !isMobile.value
}

//snackbar
const snackbar = ref({
  show: false,
  message: "",
  color: "success" // success | error | warning | info
})

const showSnackbar = (message, color = "success") => {
  snackbar.value.message = message
  snackbar.value.color = color
  snackbar.value.show = true
}

const user = computed(() => {
  return usr.singleUser?.user?.[0] || null
})
const nok = computed(() => {
  return usr.singleUser?.next_of_kin?.[0][0] || null
})

const referral_bonus = computed(() => {
  return usr.singleUser?.referral_bonus || null
})

const referral_count = computed(() => {
  return usr.singleUser?.referral_count || null
})

const walletTransactions = computed(() => {
  return (transact.usertransaction?.transaction_list || [])
    .filter(tx => tx.type !== 'investment')
})

const investmentTransactions = computed(() => {
  return (invest.userInvestment || [])
})

const isOutgoing = (type) => {
  return ['debit', 'investment', 'withdrawal'].includes(type)
}

/* Lifecycle */
onMounted(async () => {
  checkMobile()
  window.addEventListener("resize", checkMobile)
  try {
    await usr.loadSingleUser(userId)
    await transact.loadUserTransaction(userId)
    await invest.loadUserInvestments(userId)
    loading.value = false
  } catch (error) {
    console.error(error)
  }
})

// Watch tab switch
watch(
  activeTab,
  async (tab) => {

    // WALLET
    if (tab === "wallet" && transact?.loadUserTransaction) {
      loadingWallet.value = true

      try {
        await transact.loadUserTransaction(userId)
      } finally {
        loadingWallet.value = false
      }
    }

    // INVESTMENT
    if (tab === "investment" && invest?.loadUserInvestments) {
      loadingInvestment.value = true

      try {
        await invest.loadUserInvestments(userId)
      } finally {
        loadingInvestment.value = false
      }
    }

  },
  { immediate: true }
)

onUnmounted(() => {
  window.removeEventListener("resize", checkMobile)
})

const regenerateNewVA = async (user) => {
  if (!confirm(`Regenerate the virtual account for ${user.profile.firstname} ${user.profile.lastname}?`)) {
    return
  }

  regeneratingVA.value = true

  try {
    const res = await regenerateVirtualAccount(userId)

    showSnackbar(res.data?.message || "Virtual account regenerated successfully")

    // Reload the user's details so the new account number is displayed
    await usr.loadSingleUser(userId)
  } catch (error) {
     const msg = getAllErrors(error)
    showSnackbar(
      msg || "Failed to regenerate virtual account",
      "error"
    )
   
  } finally {
    regeneratingVA.value = false
  }
}

const toggleSuspension = async (user) => {

  suspendingUser.value = true
  try {
    if (user.is_suspended) {
      // Call Unsuspend API
      
      await unsuspendUser(user.uuid);
      showSnackbar("Suspension Lifted")
      user.is_suspended = false;
    } else {
      // Call Suspend API

      await suspendUser(user.uuid);
      showSnackbar("Suspend User", "info")
      user.is_suspended = true;
    }
    await usr.loadSingleUser(userId)
  } catch (error) {
    console.error(error);
    const msg = getAllErrors(error)
    showSnackbar(
      msg || "Unable to complete action",
      "error"
    )
  }finally {
    suspendingUser.value = false;
  }

};

const verifyUser = async (user) => {

  verifyingUser.value = true;
  try{
    await verifyUserAccount(user.uuid)
    showSnackbar("Account verified Succesfully")
    await usr.loadSingleUser(userId)
  }catch (error) {
    const msg = getAllErrors(error)
    showSnackbar(
      msg || "Unable to verify user",
      "error"
    )
  }finally {
    verifyingUser.value = false;
  }

}

</script>

<style scoped>
.main {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  background: #f8fafc;
}

/* Card */
.table-card {
  padding: 20px;
  border-radius: 14px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
}

/* Header */
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* Table */
.modern-table {
  border: none;
}

/* Product */
.product-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.product-image {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  object-fit: cover;
}

.product-name {
  font-weight: 700;
}

.product-desc {
  font-size: 16px;
  color: #64748b;
}

/* Status */
.status-pill {
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.status-active {
  background: #ecfdf5;
  color: #2ba316;
}

.status-inactive {
  background: #fef2f2;
  color: #dc2626;
}

.status-ongoing {
  background: #d6a11b;
  color: #f2f4f2;
}

.status-completed {
  background: #ecfdf5;
  color: #2ba316;
}

.title-separator {
  border: none;
  border-top: 1px solid #eae4e4;
  margin: 12px 0;
}

/* Button */
.theme-button {
  height: 46px;
  background: #000;
  color: #fff;
  border-radius: 10px;
  font-weight: 600;
  transition: all 0.25s ease;
}

/* Inner cards */
.inner-card {
  border: 1px solid #eae5e5;
  border-radius: 6px;
  padding: 8px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.inner-mini-card {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background: #ffffff;
}

.long-tab {
  text-transform: none;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.3px;
}

:deep(.v-tab) {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin-right: 8px;
}

:deep(.v-tab.v-tab--selected) {
  background: #025227;
  color: #fff;
}

/* Table */
.modern-table {
  border: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

:deep(.modern-table .p-datatable-thead > tr > th) {
  background: #eef7f0;
  color: #065f46;
  font-weight: 600;
  border-bottom: 2px solid #c1edc3;
}

.p-datatable-tbody>tr {
  cursor: pointer;
}

.p-datatable-tbody>tr:hover {
  background-color: #f5f5f5;
}

.profile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  width: 100%;
}

.profile-info {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.verify-btn {
  white-space: nowrap;
}

/* Mobile */
@media (max-width: 600px) {

  .profile-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .verify-btn {
    width: 100%;
    margin-top: 12px;
  }
}
</style>
